(function() {
	
	var Texture = include("PIXI.Texture"),
		Application = include("springroll.Application"),
		Sprite = include("PIXI.Sprite"),
		Container = include("PIXI.Container"),
		Tween = include("createjs.Tween"),
		Sound = include("springroll.Sound"),
		Ease = include("createjs.Ease");
	
	var SuspectPhoto = function(state, suspectId, positionData)
	{
		Container.call(this);
		
		this.position.x = positionData.x;
		this.position.y = positionData.y;
		this.pivot.x = positionData.pivotX;
		this.pivot.y = positionData.pivotY;
		if(positionData.rotation)
			this.rotation = positionData.rotation * Math.DEG_TO_RADS;
		this.startingRotation = this.rotation;
		
		this.state = state;
		
		this.id = suspectId;
		this.suspectName = suspectId.split("_")[0];
		var config = Application.instance.config.game.suspect;
		this.normalTexture = Texture.fromImage("SuspectPhoto");
		this.highlightTexture = Texture.fromImage("SuspectPhoto_highlight");
		this.overallHighlightTexture = Texture.fromImage("SuspectPhoto_overallhighlight");
		this.background = new Sprite(this.normalTexture);
		this.addChild(this.background);
		this.suspect = new Sprite(Texture.fromImage(suspectId));
		this.addChild(this.suspect);
		this.suspect.position.x = config.photoRect.x;
		this.suspect.position.y = config.photoRect.y;
		this.visible = false;
		
		this.hitArea = new PIXI.Rectangle(0, 0, this.background.width, this.background.height);
		
		var photoShake = config.photoShake;
		this.bounces = photoShake.bounces;
		var rotDist = photoShake.arc * Math.DEG_TO_RADS;
		this.minRot = this.startingRotation - rotDist;
		this.maxRot = this.startingRotation + rotDist;
		this.shakeTweenSpeed = photoShake.speed * Math.DEG_TO_RADS;
		this.isShaking = false;
		
		var photoRollover = config.photoRollover;
		this.dir = -1;
		rotDist = photoRollover.arc * Math.DEG_TO_RADS;
		this.minRolloverRot = this.startingRotation - rotDist;
		this.maxRolloverRot = this.startingRotation + rotDist;
		this.rolloverTweenSpeed = photoRollover.rolloverSpeed * Math.DEG_TO_RADS;
		this.tween = Tween.get(this).setPaused(true);
		this.bounceTween = this.bounceTween.bind(this);
		
		this.isDown = false;
		this.isOver = false;
		
		this.onUp = this.onUp.bind(this);
		this.onDown = this.onDown.bind(this);
		this.onUpOutside = this.onUpOutside.bind(this);
		this.onOver = this.onOver.bind(this);
		this.onOut = this.onOut.bind(this);
		
		this.blinkTimer = 0;
		this.blinkTime = config.photoBlinkTimer;
		
		this.highlight = this.highlight.bind(this);
		this.blinkHighlight = this.blinkHighlight.bind(this);
		this.overallHighlight = this.overallHighlight.bind(this);
		this.unhighlight = this.unhighlight.bind(this);
		this.update = this.update.bind(this);
		this.onShakeDone = this.onShakeDone.bind(this);
	};
	
	// Extend MovieClip
	var s = Container.prototype;
	var p = SuspectPhoto.prototype = Object.create(s);
	
	p.enable = function()
	{
		this.on("mousedown", this.onDown);
		this.on("touchstart", this.onDown);
		if(!Application.instance.hasTouch)
		{
			this.on("mouseover", this.onOver);
			this.on("mouseout", this.onOut);
		}
		this.interactive = true;
		this.buttonMode = true;
	};
	
	p.shake = function()
	{
		this.isShaking = true;
		Tween.removeTweens(this);
		var tween = Tween.get(this), dir = 1, rotation = this.rotation, time, target;
		for(var i = 0; i < this.bounces; ++i)
		{
			target = dir < 0 ? this.minRot : this.maxRot;
			//convert angular delta to milliseconds
			time = Math.abs(rotation - target) / this.shakeTweenSpeed * 1000;
			tween.to({rotation:target}, time, createjs.Ease.quadInOut);
			//reverse direction
			dir *= -1;
			//save rotation for next round
			rotation = target;
		}
		target = this.startingRotation;
		//convert angular delta to milliseconds
		time = Math.abs(rotation - target) / this.shakeTweenSpeed * 1000;
		tween.to({rotation:target}, time, createjs.Ease.quadInOut).call(this.onShakeDone);
	};
	
	p.onShakeDone = function()
	{
		this.isShaking = false;
		if(this.isOver)
			this.startRollover();
	};
	
	p.disable = function()
	{
		this.off("mousedown", this.onDown);
		this.off("touchstart", this.onDown);
		this.off("mouseover", this.onOver);
		this.off("mouseout", this.onOut);
		this.off("mouseup", this.onUp);
		this.off("touchend", this.onUp);
		this.off("mouseupoutside", this.onUpOutside);
		this.off("touchendoutside", this.onUpOutside);
		this.interactive = false;
		this.buttonMode = false;
		this.unhighlight();
		if(this.isOver || this.isShaking)
		{
			this.isOver = false;
			this.isShaking = false;
			this.onOut();
		}
	};
	
	p.onUp = function()
	{
		this.off("mouseup", this.onUp);
		this.off("touchend", this.onUp);
		this.off("mouseupoutside", this.onUpOutside);
		this.off("touchendoutside", this.onUpOutside);
		
		this.state.photoClicks++;
		Sound.instance.play("SFX_PhotoClick");
		this.state.onSuspectClicked(this.id);
	};
	
	p.onDown = function()
	{
		this.on("mouseup", this.onUp);
		this.on("touchend", this.onUp);
		this.on("mouseupoutside", this.onUpOutside);
		this.on("touchendoutside", this.onUpOutside);
	};
	
	p.onUpOutside = function()
	{
		this.off("mouseup", this.onUp);
		this.off("touchend", this.onUp);
		this.off("mouseupoutside", this.onUpOutside);
		this.off("touchendoutside", this.onUpOutside);
	};
	
	p.onOver = function()
	{
		this.isOver = true;
		this.state.photoHovers++;
		Sound.instance.play("SFX_PhotoHover");
		
		if(this.isShaking) return;
		
		this.startRollover();
	};
	
	p.startRollover = function()
	{
		Tween.removeTweens(this);
		this.tween.reset();
		var target = this.dir < 0 ? this.minRolloverRot : this.maxRolloverRot;
		//convert distance to milliseconds
		var time = Math.abs(this.rotation - target) / this.rolloverTweenSpeed * 1000;
		tweenHelper.rotation = target;
		this.tween.setPaused(false).to(tweenHelper, time, Ease.quadInOut).call(this.bounceTween);
	};
	
	var tweenHelper = {rotation:0};

	p.bounceTween = function()
	{
		Tween.removeTweens(this);
		this.tween.reset();
		this.dir *= -1;
		var target = this.dir < 0 ? this.minRolloverRot : this.maxRolloverRot;
		//convert distance to milliseconds
		var time = Math.abs(this.rotation - target) / this.rolloverTweenSpeed * 1000;
		tweenHelper.rotation = target;
		this.tween.setPaused(false).to(tweenHelper, time, Ease.quadInOut).call(this.bounceTween);
	};

	p.onOut = function()
	{
		this.isOver = false;
		if(this.isShaking) return;
		
		Tween.removeTweens(this);
		this.tween.reset();
		var target = this.startingRotation;
		//convert distance to milliseconds
		var time = Math.abs(this.rotation - target) / this.rolloverTweenSpeed * 1000;
		this.dir = target < this.rotation ? -1 : 1;
		tweenHelper.rotation = target;
		this.tween.setPaused(false).to(tweenHelper, time, Ease.quadInOut);
	};
	
	p.overallHighlight = function()
	{
		this.background.texture = this.overallHighlightTexture;
	};
	
	p.blinkHighlight = function()
	{
		this.highlight(true);
	};
	
	p.highlight = function(blink)
	{
		this.background.texture = this.highlightTexture;
		if(blink)
		{
			Application.instance.on("update", this.update);
			this.blinkTimer = this.blinkTime;
		}
		else
			Application.instance.off("update", this.update);
	};
	
	p.unhighlight = function()
	{
		this.background.texture = this.normalTexture;
		Application.instance.off("update", this.update);
	};
	
	p.update = function(elapsed)
	{
		this.blinkTimer -= elapsed;
		if(this.blinkTimer <= 0)
		{
			this.blinkTimer += this.blinkTime;
			var bg = this.background;
			bg.texture = bg.texture == this.normalTexture ?
							this.highlightTexture : this.normalTexture;
		}
	};
	
	p.destroy = function()
	{
		s.destroy.call(this);
		this.background.destroy();
		this.suspect.destroy();
		Application.instance.off("update", this.update);
		Tween.removeTweens(this);
		this.background = this.suspect = this.hitArea = this.state = this.normalTexture =
			this.highlightTexture = this.blinkHighlight = this.update = this.highlight =
			this.unhighlight = this.tween = this.onUp = this.onUpOutside = this.onDown =
			this.onOver = this.onOut = null;
	};
	
	namespace('heist').SuspectPhoto = SuspectPhoto;
}());